// extracted by mini-css-extract-plugin
module.exports = {"cards":"c6e8ba5398--cards--335wn","card":"c6e8ba5398--card--2xflt"};